import TagManager from 'react-gtm-module';
import { GOOGLE_TM_ID } from '../../config';

const init = (gtmId = GOOGLE_TM_ID) => TagManager.initialize({ gtmId });

// example
const dataLayer = () =>
  TagManager.dataLayer({
    dataLayer: {
      userId: '001',
      userProject: 'project',
      page: 'home',
    },
    dataLayerName: 'PageDataLayer',
  });

const GoogleTagManager = {
  init,
  dataLayer,
};

export default GoogleTagManager;
